import { UNIT } from '~/environment-variables/unit.const'
import type { Column } from '~/ui/Table/types'

const internalTransactionColumn: Array<Column> = [
  {
    name: 'TXN HASH',
    field: 'PTRXHA',
  },
  {
    name: 'TYPE',
    field: 'TMT',
  },
  {
    name: 'FROM',
    field: 'fromAddress',
  },
  {
    name: '',
    field: 'arrow-right',
  },
  {
    name: 'TO',
    field: 'toAddress',
  },
  {
    name: 'VALUE',
    field: 'VA',
    unit: UNIT,
    isHoverable: true,
  },
]

export { internalTransactionColumn }